"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toAngiLeadsProviderProps = exports.isAngiLeadsPermission = exports.doesUserHaveDelegatedAccessToBusiness = exports.angiUtils = exports.angiLeadsUtils = exports.ANGI_LEADS_ASSOCIATE = exports.ANGI_LEADS_ADMIN = void 0;

var _isEmpty3 = _interopRequireDefault(require("lodash/isEmpty"));

var _get3 = _interopRequireDefault(require("lodash/get"));

var ANGI_LEADS_ADMIN = 'AngiLeadsAdmin';
exports.ANGI_LEADS_ADMIN = ANGI_LEADS_ADMIN;
var ANGI_LEADS_ASSOCIATE = 'AngiLeadsAssociate';
exports.ANGI_LEADS_ASSOCIATE = ANGI_LEADS_ASSOCIATE;
var ANGI_LEADS_PERMISSIONS = [ANGI_LEADS_ADMIN, ANGI_LEADS_ASSOCIATE];
var angiLeadsUtils = {
  isOnAngiLeadsPage: function isOnAngiLeadsPage(path) {
    var regex = new RegExp('/app/h/.*');
    var matches = regex.exec(path);
    return !(0, _isEmpty3["default"])(matches);
  },
  getUserPermissionToLeadsBusiness: function getUserPermissionToLeadsBusiness(entitlements, spId) {
    if (!Array.isArray(entitlements) || !spId) return '';
    var foundEntitlement = entitlements.find(function (entitlement) {
      return entitlement.scopeId === "HA-".concat(spId);
    });
    return (foundEntitlement === null || foundEntitlement === void 0 ? void 0 : foundEntitlement.permission) || '';
  }
};
exports.angiLeadsUtils = angiLeadsUtils;

var toAngiLeadsProviderProps = function toAngiLeadsProviderProps(providerInfoPayload, spId) {
  return {
    city: (0, _get3["default"])(providerInfoPayload, 'payload.address.city', ''),
    displaySpId: spId,
    // todo: update from new activity notification endpoint when complete
    hasOpportunityNotifications: false,
    name: (0, _get3["default"])(providerInfoPayload, 'payload.name', ''),
    instantBookingEnabled: (0, _get3["default"])(providerInfoPayload, 'payload.properties.instantBookingEnabled'),
    proType: 'Angi Leads',
    calendarSyncStatus: (0, _get3["default"])(providerInfoPayload, 'payload.calendarSyncStatus', ''),
    rating: (0, _get3["default"])(providerInfoPayload, 'payload.ratingInfo.rating', 0.0),
    reviewCount: (0, _get3["default"])(providerInfoPayload, 'payload.ratingInfo.reviewCount', 0),
    receivingLeads: (0, _get3["default"])(providerInfoPayload, 'payload.leadFlowDetails.receivingLeads', true),
    leadsResumeDate: (0, _get3["default"])(providerInfoPayload, 'payload.leadFlowDetails.pauseEndDate'),
    state: (0, _get3["default"])(providerInfoPayload, 'payload.address.stateAbbreviation', ''),
    spId: spId
  };
};

exports.toAngiLeadsProviderProps = toAngiLeadsProviderProps;

var doesUserHaveDelegatedAccessToBusiness = function doesUserHaveDelegatedAccessToBusiness(userDelegatedServiceProviderIds, spId) {
  var modifiedSpid = "HA-".concat(spId);
  return Object.values(userDelegatedServiceProviderIds).some(function (serviceProviderId) {
    return serviceProviderId === modifiedSpid;
  });
};

exports.doesUserHaveDelegatedAccessToBusiness = doesUserHaveDelegatedAccessToBusiness;

var isAngiLeadsPermission = function isAngiLeadsPermission(permission) {
  return ANGI_LEADS_PERMISSIONS.includes(permission);
};

exports.isAngiLeadsPermission = isAngiLeadsPermission;
var leadsSubNavExclusions = ['opportunities', 'messages'];
var adsSubNavExclusions = ['leads', 'messages'];
var angiUtils = {
  isOnBusinessContextPage: function isOnBusinessContextPage(path) {
    if (path === '/app/home' || path === '/app/home/' || path.includes('/app/account') || path === '') {
      return false;
    }

    return path.includes('/app');
  },
  calculateShowHeaderSubNav: function calculateShowHeaderSubNav(isAngiLeads, currentSubNav) {
    if (currentSubNav === undefined) return false;
    var exclusions = isAngiLeads ? leadsSubNavExclusions : adsSubNavExclusions;
    return !exclusions.includes(currentSubNav);
  }
};
exports.angiUtils = angiUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/util/angiLeadsUtils.js
// module id = 577
// module chunks = 25